export default {
  inheritAttrs: false,
  components: {},
  props: ['data'],
  data: function data() {
    return {
      ruleForm: {
        probeName: "",
        probeEnName: "",
        remarkInfo: "",
        probeStatus: "2",
        defaultPath: ""
      },
      rules: {
        day: [{
          required: true,
          message: "必填",
          trigger: ["blur", "change"]
        }]
      },
      disLoading: false
    };
  },
  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    onOpen: function onOpen() {
      this.ruleForm = {
        probeName: "",
        probeEnName: "",
        remarkInfo: "",
        probeStatus: "2",
        defaultPath: ""
      };
      if (this.data != null) {
        this.ruleForm = Object.assign({}, this.data);
      }
    },
    onClose: function onClose() {},
    close: function close() {
      this.$emit("update:visible", false);
    },
    handelConfirm: function handelConfirm() {
      var _this = this;
      this.$refs["ruleForm"].validate(function (valid) {
        if (!valid) return;
        if (_this.data) {
          // this.updateUser();
        } else {
          // this.addUser();
        }
      });
    },
    renew: function renew() {
      this.disLoading = true;
      // addUser(this.ruleForm).then(res => {
      //     this.$message.success(res.message); 
      //     this.disLoading = false;
      //     this.close();
      //     this.$emit('confirm');
      // }).catch(err => {
      //     this.disLoading = false;
      // })
    },
    updateUser: function updateUser() {
      this.disLoading = true;
      // updateUser(this.ruleForm).then(res => {
      //     this.$message.success(res.message);
      //     this.disLoading = false;
      //     this.close();
      //     this.$emit('confirm');
      // }).catch(err => {
      //     this.disLoading = false;
      // })
    }
  }
};